import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Label from 'components/_utility/Label';
import { getPackPendingRemoval } from 'src/redux/bike/selectors';
import PackChoiceGroup from 'components/PackChoiceGroup/PackChoiceGroup';
import { Wrap, Heading, Title, Description, Actions, ConfirmButton, CancelButton } from '../ConflictingAccessories/ConflictingAccessories.styled';
import { closeAccessoryResolution, removePack } from 'src/redux/bike/actions';

const RemovePack = () => {
  const dispatch = useDispatch();
  const packPendingRemoval = useSelector(getPackPendingRemoval);

  return (
    <Wrap>
      <Title>
        <Label name="removePackTitle" />
      </Title>
      <Description>
        <Label name="removePackDescription" />
      </Description>
      <Heading>
        <Label name="packLabel" />
      </Heading>
      <PackChoiceGroup pack={packPendingRemoval} noChoice />

      <Actions>
        <ConfirmButton primary onClick={() => dispatch(removePack())}>
          <Label name="confirmLabel"></Label>
        </ConfirmButton>
        <CancelButton onClick={() => dispatch(closeAccessoryResolution())}>
          <Label name="cancelLabel"></Label>
        </CancelButton>
      </Actions>
    </Wrap>
  );
};

export default RemovePack;
